import * as React from "react";
import { connect } from "react-redux";
import { mapDispatchToProps } from "../../redux/actions";
import { deleteUnitPrompt, openUnitCopyModal, openProUnitPrompt, openInactiveUnitPrompt, updateUnitStatusById, editUnitQuantityAndTags } from "./ProjectUtilities";
import { getNumericId } from "../../api-utilities/formatting";
import "../../css/Project.scss";
import { formatNumber, resetReduxModals } from "../../utilities/helpers";

// expected props
interface IProps {
  updateRedux: any;
  unit: any;
  projectId: string;
  history: any;
  reduxDisplay: any;
  reduxModals:any;
}
// local state
interface IState {}

class Unit extends React.Component<IProps, IState> {
  public state: IState = {};

  //This is a specific modal for copying a unit to the project selected by the user.
  componentDidUpdate(prevProps: IProps){
    const modal = this.props.reduxModals;
    //If submittal modal state changed from open to closed
    if (prevProps.reduxModals.showModal !== modal.showModal && modal.showModal === false) {
      if (modal.modalId === 'pro-unit' && modal.userResponse.response === 'ok') {
        //Send user to factory request page.
        let projectId = getNumericId(this.props.projectId);
        let unitId = modal.modalData.clickedUnit;
        const unitNumberOnly = unitId.split("-")[1];
        this.props.history.push("/pid/" + projectId + "/uid/" + unitNumberOnly + "/factoryrequests/factoryrequestmain");
        resetReduxModals();
      }
      else if (modal.modalId === 'pro-unit' && modal.userResponse.response === 'cancel'){
        resetReduxModals();
      }      
    }
  }

  public render() {
    let isProEditMode = this.props.unit.isProEditMode;
    let spinnerClass = this.props.reduxDisplay.unitToDelete === this.props.unit.id ? "" : "app-display-none";
    let unitPrice = this.props.unit.unitPrice ? "$" + formatNumber(this.props.unit.unitPrice, 0) : "-";
    let priceAvailable = this.props.unit.isPriceAvailable;
    let isActive = this.props.unit.isActive;
    let isLocked = this.props.unit.isLocked;
    let rowClass = "proj-unit-tr";
    if (isProEditMode){
      rowClass += " is-purple";
    }
    if(!isActive){
      rowClass += " is-inactive";
    }
    let copyClass = isProEditMode ? "proj-unit-td proj-link-white" : "proj-unit-td proj-link";
    let deleteClass = this.props.reduxDisplay.unitToDelete === this.props.unit.id ? "app-display-none" : "proj-unit-td proj-link";

    const handleStatusToggle = (event: React.SyntheticEvent<HTMLDivElement>, EventTargetChecked: boolean) => {
      event.stopPropagation();
      if(!isLocked){
        updateUnitStatusById(this.props.unit.id, EventTargetChecked);
      }
    };

    return (
      <div className={rowClass} onClick={() => this.editUnit(this.props.unit)}>
        {/* The "title" property enables tooltips when user mouses over a long unitTag  */}
        <div title={this.props.unit.unitTag} className="proj-unit-td-name">
          {isProEditMode ? (
            <>
              <div className="proj-lock-icon"></div>
              <div className="proj-lock-spacer"></div>
            </>
          ) : null}

          {/* <div className="proj-unit-tag">{this.props.unit.unitTag}</div> */}

          {this.props.unit.unitTag}
        </div>
        {/* The "title" property enables tooltips when user mouses over a long modelNumber  */}
        <div title={this.props.unit.modelNumber} className="proj-unit-td-model">
          {this.props.unit.modelNumber}
        </div>
        <div className="proj-unit-td-id">{this.props.unit?.id?.split("-")?.[1] ?? ""}</div>
        <div className="proj-unit-td-price">{priceAvailable && !isProEditMode ? unitPrice : "-"}</div>
        <div className={isLocked ? "proj-unit-td-status locked" : "proj-unit-td-status"} onClick={(event)=> handleStatusToggle(event, !(isActive))}>
          <div className={`status-slider ${isActive ? "is-active" : "is-inactive"}`}>
            <span className = "slider-text">{isActive ? "Active" : "Inactive"}</span>
          </div>
        </div>
        <div className="proj-unit-td-qty">{this.props.unit.unitQuantity}</div>
        <div className="copy-delete-container">
        <div className={copyClass} onClick={(event) => editUnitQuantityAndTags(event, this.props.unit.id, this.props.projectId)}>
            tags
          </div>
          <div className={copyClass} onClick={(event) => openUnitCopyModal(event, this.props.unit)}>
            copy
          </div>
          <div className={deleteClass} onClick={(event) => deleteUnitPrompt(event, this.props.unit)}>
            delete
          </div>

          <div className={spinnerClass + " proj-unit-td"}>
            <div className="spinner"></div>
          </div>
        </div>
      </div>
    );
  }
  private editUnit(unit: any) {
    if (unit.isProEditMode) {
      openProUnitPrompt(this.props.unit);
      return;
    }else if (unit.isActive === false){
      openInactiveUnitPrompt(this.props.unit);
      return;
    } else if (unit.isLocked){
      return;
    }

    let projectId = getNumericId(this.props.projectId);
    let unitId = getNumericId(this.props.unit.id);
    this.props.history.push("/pid/" + projectId + "/uid/" + unitId + "/design/unittype");
  }
}

//------------------ Redux ----------------------------
function mapStateToProps(state: any) {
  return { 
    reduxDisplay: state.reduxDisplay,
    reduxModals: state.reduxModals
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(Unit);
